(() => {
  const sticky = document.querySelector('[data-sticky-atc]')
  const stickyButton = document.querySelector('[data-sticky-atc-button]')
  const mainButton = document.querySelector('[data-product-atc]')
  const sizeFieldset = document.querySelector('.prd-Product_SizeFieldset')

  if (!sticky || !stickyButton || !mainButton) return

  const mq = window.matchMedia('(max-width: 989px)')

  const syncVisibility = (entries) => {
    if (!mq.matches) {
      sticky.hidden = true
      sticky.classList.remove('is-visible')
      return
    }

    const entry = entries[0]
    const shouldShow = entry && !entry.isIntersecting

    sticky.hidden = !shouldShow
    sticky.classList.toggle('is-visible', shouldShow)
  }

  const observer = new IntersectionObserver(syncVisibility, {
    threshold: 0,
    rootMargin: '0px 0px 0px 0px',
  })

  observer.observe(mainButton)

  stickyButton.addEventListener('click', () => {
    if (mainButton.disabled) {
      if (sizeFieldset) {
        sizeFieldset.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })

        return
      }

      mainButton.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })

      return
    }

    mainButton.click()
  })

  mq.addEventListener('change', () => {
    if (!mq.matches) {
      sticky.hidden = true
      sticky.classList.remove('is-visible')
    }
  })
})()
